import { Series } from './../../models';
import { Component, OnInit,ViewContainerRef } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { EcomicService } from '../../service/comics/ecomic.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
declare const swal: any;
declare var $: any;
@Component({
  selector: 'app-e-comic-series',
  templateUrl: './e-comic-series.component.html',
  styleUrls: ['./e-comic-series.component.css']
})
export class EComicSeriesComponent implements OnInit {
  Ecomicseriescol: AngularFirestoreCollection<Series>;
  Ecomicseries: Observable<Series[]>;
  status: any = 'All';
  id:any;
  constructor(private afs: AngularFirestore, private comicservice:EcomicService,public toastr: ToastsManager,vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
   }

  ngOnInit() {
   this.filterseries('All');
  }

  filterseries(status) {
    this.Ecomicseriescol = this.afs.collection('Ecomicseries', res => {
      if (status === 'All') {
        return res.orderBy('createdAt', 'desc')
      } else {
        return res.orderBy('createdAt', 'desc').where('status', '==', status);
      }
    });
    this.Ecomicseries = this.Ecomicseriescol.valueChanges();
    this.Ecomicseries.subscribe(data => {
    });
  }

  delete(id) {
    console.log(id);
    this.id = id;
    $("#DeleteModal").modal();
  }
  deletedata() {
    $('#DeleteModal').modal('hide');
    this.comicservice.deleteseries('Ecomicseason','comic_series',this.id).then(status =>{
      if(status){
        this.afs.doc('/Ecomicseries/'+this.id).delete().then(function () {  
          swal('Deleted!', 'Your List has been deleted.', 'success');
        }).catch(function(error){
          swal('Error!', error, 'error');
         
          console.error("error in removing document:",error);
        });
      } else {
        swal('Error!', 'Your are not permitted to delete.', 'error');
        console.log('not permited');
        // this.toastr.error('Cant delete,seasons are available in this series!', 'Oops!');
      }
    })
  }
    

}



// WEBPACK FOOTER //
// ./src/app/E-comics/e-comic-series/e-comic-series.component.ts